import React, { useCallback } from 'react';
import DateBox from 'devextreme-react/date-box';
import Validator, { RequiredRule, RangeRule, CustomRule } from 'devextreme-react/validator';
import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import './FormDateBox.scss';
export const FormDateBox = ({
    value,
    readOnly,
    name,
    label,
    onValueChange,
    calenderOptions,
    minName,
    minValue,
    required = false,
    children,
    dateSerializationFormat,
    placeholder,
    validationMessage= '',
    type = 'date',
    isEditing,
    stylingMode = 'filled'
}) => {
    const validateDate = (e, minDate) => {
        dayjs.extend(isSameOrAfter);
        var nDate = dayjs(e.value);
        var cDate = dayjs(minDate);
        var result = nDate.isSameOrAfter(cDate, 'day') // compare day
        return result;
        //return e.value >= minDate;
    }

    const handleKeyDown = useCallback((e) => {
        const key = e.event?.key || e.event?.code;
        if (key === 'ArrowDown' && !e.event.altKey && !e.event.ctrlKey && !e.event.metaKey && !e.event.shiftKey) {
            e.component?.open?.();
            e.event.preventDefault();
        }
    }, []);

    return (
        <DateBox
            value={value}
            readOnly={readOnly || !isEditing}
            name={name}
            label={label}
            calendarOptions={calenderOptions ? calenderOptions : undefined}
            inputAttr={{ class: 'form-editor-input', 'aria-label': label }}
            stylingMode={stylingMode}
            displayFormat='shortdate'
            dateSerializationFormat= {dateSerializationFormat ? dateSerializationFormat : 'yyyy-MM-dd'}
            placeholder={placeholder ? placeholder : 'MM/dd/yyyy'}
            useMaskBehavior={true}
            onValueChange={onValueChange}
            onKeyDown={handleKeyDown}
            type={type}
        // isValid={value && value >= minValue}
        // invalidDateMessage={value ? name + 'must be equal to or greater than' + minName : name + 'is required'}
        >
            {required &&
                <Validator>
                    {required && <RequiredRule message={label + ' is required'} validationMessage={validationMessage} />}
                    {children}
                    {/* {minValue && minName &&
                        <CustomRule type='custom' validationCallback={(e) => validateDate(e, minValue)} reevaluate={true} message={name + ' must be equal to or greater than ' + minName} />
                     } */}
                </Validator>
            }
        </DateBox>
    );
};